import { Button } from '@app/app/_components/Button/Button';
import { Heading } from '@app/app/_components/Heading/Heading';
import { Paragraph } from '@app/app/_components/Paragraph/Paragraph';
import { ArrowRightIcon } from '@app/app/_icons/ArrowRightIcon';
import { CheckmarkCircleIcon } from '@app/app/_icons/CheckmarkCircleIcon';
import { useTranslations } from 'next-intl';

interface Props {
    toTheHomepage: () => void;
}

export function HealthQuestionsSuccess({ toTheHomepage }: Props) {
    const t = useTranslations();
    return (
        <div className="flex flex-col items-center py-8 max-md:px-2">
            <CheckmarkCircleIcon className="size-18 text-primary-400" />
            <div className="mb-8 mt-6 flex flex-col gap-2 px-4 text-center">
                <Heading className="font-normal max-md:text-2xl">{t('general.thankYou')}</Heading>
                <Paragraph className="mt-8 max-w-[550px]">{t('eshop.life.weWillContactYou')}</Paragraph>
            </div>
            <div className="fixed inset-x-0 bottom-0 z-10 flex w-full justify-stretch bg-white shadow-lg-up md:justify-center">
                <div className="flex w-full items-center px-4 py-6 md:min-w-dialog md:max-w-dialog md:px-0">
                    <Button
                        className="w-full"
                        onClick={toTheHomepage}
                        rightAddon={<ArrowRightIcon className="size-4" />}>
                        {t('eshop.life.toTheHomepage')}
                    </Button>
                </div>
            </div>
        </div>
    );
}
